<template>
  <ViewWrapper class="not-found">
    <h1>{{ $t('view.notFound.headline') }}</h1>
    <p>{{ $t('view.notFound.copy') }}</p>
  </ViewWrapper>
</template>

<script>
import ViewWrapper from '../components/ViewWrapper';

export default {
  name: 'NotFound',

  components: {
    ViewWrapper,
  },
};
</script>
<style lang="scss" scoped>
.not-found {
  padding: 20px;

  h1 {
    font-size: 35px;
    text-align: center;
    margin-bottom: 20px;
    font-weight: bold;
  }
  p {
    line-height: 26px;
    margin-bottom: 40px;
    text-align: center;
  }
}
</style>
